import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";

export interface ExamenRealizado {
  id?: number;

  cedula?: number;

  id_examen_medico: number;

  examen: number;

  realizo: number | null;

  tipo_examen: number | null;

  descripcion?: string | null;

  estado?: number;

  fecha_creacion?: Date | string;

  fecha_modificacion?: Date | string;

  usuario_creacion?: number | null;

  usuario_modificacion?: number | null;
}

@Injectable({
  providedIn: "root",
})
export class ExamenesRealizadosService {
  private apiUrl = `${environment.apiUrl}/api/examenes_realizados`;

  constructor(private http: HttpClient) {}

  // =========================
  // GET ALL
  // =========================
  getExamenesRealizados(): Observable<ExamenRealizado[]> {
    return this.http.get<ExamenRealizado[]>(this.apiUrl, {
      withCredentials: true,
    }).pipe(
      catchError((error) => throwError(() => error))
    );
  }

  // =========================
  // GET BY ESTADO
  // =========================
  getExamenesRealizadosByEstado(estado: number | string): Observable<ExamenRealizado[]> {
    return this.http.get<ExamenRealizado[]>(`${this.apiUrl}/estado/${estado}`, {
      withCredentials: true,
    }).pipe(
      catchError((error) => throwError(() => error))
    );
  }

  // =========================
  // GET BY EXAMEN MEDICO
  // =========================
  getExamenRealizadoByExamenMedico(
    id: number | string
  ): Observable<ExamenRealizado[]> {
    return this.http.get<ExamenRealizado[]>(
      `${this.apiUrl}/examen_medico/${id}`,
      { withCredentials: true }
    ).pipe(
      catchError((error) => throwError(() => error))
    );
  }

  // =========================
  // CREATE
  // =========================
  createExamenRealizado(payload: ExamenRealizado): Observable<ExamenRealizado> {
    return this.http.post<ExamenRealizado>(this.apiUrl, payload, {
      withCredentials: true,
    }).pipe(
      catchError((error) => throwError(() => error))
    );
  }

  // =========================
  // UPDATE
  // =========================
  updateExamenRealizado(
    id: number | string,
    payload: ExamenRealizado
  ): Observable<ExamenRealizado> {
    return this.http.put<ExamenRealizado>(`${this.apiUrl}/${id}`, payload, {
      withCredentials: true,
    }).pipe(
      catchError((error) => throwError(() => error))
    );
  }

  // =========================
  // DELETE
  // =========================
  deleteExamenRealizado(id: number | string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`, {
      withCredentials: true,
    }).pipe(
      catchError((error) => throwError(() => error))
    );
  }

  // =========================
  // BY CEDULA
  // =========================
  getExamenesRealizadosByCedula(cedula: string): Observable<ExamenRealizado[]> {
    return this.http.get<ExamenRealizado[]>(
      `${this.apiUrl}/cedula/${cedula}`,
      { withCredentials: true }
    ).pipe(
      catchError((error) => throwError(() => error))
    );
  }

  // =========================
  // INACTIVAR
  // =========================
  inactivarExamenesRealizadosPorExamenMedico(
    id_examen_medico: number
  ): Observable<any> {
    return this.http.put(
      `${this.apiUrl}/${id_examen_medico}/inactivar`,
      { estado: 0 },
      { withCredentials: true }
    ).pipe(
      catchError((error) => throwError(() => error))
    );
  }
}